import React from 'react';
import skyLoader from "../../assets/home-assets/skyLoader.gif";

/**
 * Component for displaying historical emissions data in a table
 */
const EmissionsHistoryTable = ({ emissionsData, loading }) => {
  // Format number with commas and decimals
  const formatNumber = (value, decimals = 2) => {
    if (!value) return '0';
    return parseFloat(value).toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  };

  // Format date from timestamp
  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    return new Date(timestamp * 1000).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  };

  // No emissions data available
  if (!loading && (!emissionsData || emissionsData.length === 0)) {
    return (
      <div className="text-center py-8 bg-gray-50 rounded-lg border border-gray-200">
        <p className="text-gray-500">No emissions data available for this project yet.</p>
        <p className="text-sm text-gray-400 mt-2">Data will appear here after the first epoch is completed.</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      {loading ? (

        <div className="flex justify-center items-center min-h-screen ">
          <img
            src={skyLoader}
            alt="Loading..."
            className="w-100 h-100 object-contain"
          />
        </div>
      ) : (
        <table className="min-w-full divide-y divide-gray-200 border border-gray-200 rounded-lg overflow-hidden">
          <thead>
            <tr className="bg-gradient-to-r from-indigo-50 to-blue-50">
              <th scope="col" className="px-4 py-3 text-left text-xs font-semibold text-indigo-700 uppercase tracking-wider">
                Epoch
              </th>
              <th scope="col" className="px-4 py-3 text-left text-xs font-semibold text-indigo-700 uppercase tracking-wider">
                Total Emissions
              </th>
              <th scope="col" className="px-4 py-3 text-left text-xs font-semibold text-indigo-700 uppercase tracking-wider">
                Project Emissions
              </th>
              <th scope="col" className="px-4 py-3 text-left text-xs font-semibold text-indigo-700 uppercase tracking-wider">
                Project Share
              </th>
              <th scope="col" className="px-4 py-3 text-left text-xs font-semibold text-indigo-700 uppercase tracking-wider">
                IU Holders Rewards
              </th>
              <th scope="col" className="px-4 py-3 text-left text-xs font-semibold text-indigo-700 uppercase tracking-wider">
                Stakers Rewards
              </th>
              <th scope="col" className="px-4 py-3 text-left text-xs font-semibold text-indigo-700 uppercase tracking-wider">
                Treasury Rewards
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {emissionsData.map((epoch, index) => (
              <tr
                key={epoch.epochNumber}
                className={index % 2 === 0 ? 'bg-white hover:bg-blue-50' : 'bg-gray-50 hover:bg-blue-50'}
                style={{ transition: 'background-color 0.2s' }}
              >
                <td className="px-4 py-4 whitespace-nowrap">
                  <div className="flex flex-col">
                    <span className="text-sm font-medium text-gray-900">Epoch {epoch.epochNumber}</span>
                  </div>
                </td>
                <td className="px-4 py-4 whitespace-nowrap">
                  <div className="text-sm font-medium text-gray-900">{formatNumber(epoch.totalEmissions.formatted)} CEL</div>
                </td>
                <td className="px-4 py-4 whitespace-nowrap">
                  <div className="text-sm font-medium text-gray-900">{formatNumber(epoch.projectEmissions.formatted)} CEL</div>
                </td>
                <td className="px-4 py-4 whitespace-nowrap">
                  <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-green-100 text-green-800">
                    {formatNumber(epoch.projectSharePercentage)}%
                  </span>
                </td>
                <td className="px-4 py-4 whitespace-nowrap">
                  <div className="text-sm font-medium text-blue-600">{formatNumber(epoch.iuHolderEmissions.formatted)} CEL</div>
                  <div className="text-xs text-gray-500">{formatNumber(epoch.iuHolderSharePercentage)}% of project</div>
                </td>
                <td className="px-4 py-4 whitespace-nowrap">
                  <div className="text-sm font-medium text-purple-600">{formatNumber(epoch.stakingEmissions.formatted)} CEL</div>
                  <div className="text-xs text-gray-500">{formatNumber(epoch.stakingSharePercentage)}% of project</div>
                </td>
                <td className="px-4 py-4 whitespace-nowrap">
                  <div className="text-sm font-medium text-amber-600">{formatNumber(epoch.treasuryEmissions.formatted)} CEL</div>
                  <div className="text-xs text-gray-500">{formatNumber(epoch.treasurySharePercentage)}% of project</div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default EmissionsHistoryTable; 